<template>
  <div class="blog">
    <div class="container background-container">
      <div class="row">
        <div class="col-md-12 p-0 pt-4">
          <img
            class="blog__header-image"
            src="@/assets/images/blog/georgia/header.jpg"
            alt="header-image"
          />
        </div>
      </div>
    </div>

    <div class="container p-md-0">
      <div class="row">
        <div class="col-md-12 p-md-0">
          <h1 class="blog__title">
            Lockdown weight loss journey leads to cookery book
          </h1>
        </div>
      </div>

      <div class="row position-relative">
        <div
          v-if="userAgent && !isInstagramBrowser"
          class="blog__social d-md-flex d-none"
        >
          <span class="blog__social-title">Share</span>
          <div
            v-for="(link, key) in socialLinks"
            :key="key"
            class="mt-2"
            @click="handleShareClick"
          >
            <img :src="getImageItem(key)" :alt="key" />
          </div>
        </div>
        <div class="col-md-8 offset-md-2">
          <p>
            A WOMAN who started her weight loss journey during lockdown and has
            inspired thousands of followers, has published her first cookery
            book.
          </p>
          <p>
            Twenty-six-year-old Georgia Webb, an admin manager with the NHS,
            lost three stones after making the decision to use her love of
            cooking to make a positive impact on her life.
          </p>
          <p>
            Georgia, from Bournemouth, decided to share her personal experience
            on social media, rapidly gaining tens of thousands of followers.
          </p>

          <p>
            And her positive point of view, promoting “moderation over
            restriction” has now led to her favourite recipes featuring in her
            Eat Well With Georgia cookbook.
          </p>

          <img
            class="blog__landscape-image"
            src="@/assets/images/blog/georgia/2.jpg"
            alt="image"
          />

          <p>
            “I was fairly unhappy when I started out on this journey and I went
            on Tik Tok to express myself,” said Georgia.
          </p>

          <p>
            “I just wanted to put out a positive message for me and for other
            people about how you can lose weight in a slow and sustainable way
            and then keep it off without having to deprive yourself.
          </p>
          <p>
            “People often fall into the trap of thinking some foods are “bad” or
            that you need to have cheat days.
          </p>
          <p>
            “My aim is to show people that you don’t need to feel guilty, you
            can enjoy food from all of the food groups and that you can enjoy
            everything in moderation.”
          </p>
          <p>
            Georgia’s book is packed with recipes that seem surprising for a
            “diet” cookbook, with her versions of dishes such as chicken
            nuggets, crispy cod burgers, pizza and even chocolate flapjacks.
          </p>
          <p>
            The book contains 50 of her favourite recipes, many of which she
            also shared on her eatwellwithgeorgia Instagram and
            @eatwellwithgeorgia Tik Tok where she has around 159k followers.
          </p>
        </div>

        <div class="col-md-8 offset-md-2">
          <div class="blog__double-image">
            <img src="@/assets/images/blog/georgia/3.jpg" alt="image" />
            <img src="@/assets/images/blog/georgia/4.jpg" alt="image" />
          </div>
        </div>

        <div class="col-md-8 offset-md-2 mt-3">
          <p>
            Her book has been created thanks to Found, an innovative company
            which helps social media recipe creators turn their content into
            cash with no cost to them at all.
          </p>
          <p>
            The company works with the creator to produce the books, where they
            get a percentage of everyone sold, with their only commitment being
            promoting the book via their channels.
          </p>

          <div class="blog__quote my-5">
            <p>
              “At first I thought it was just too good to be true but it’s an
              absolutely amazing opportunity,” said Georgia.
            </p>
          </div>

          <p>
            “It was really emotional when the book first arrived. The reactions
            so far have been really positive.
          </p>
          <p>
            “I have a fantastic community on my socials, and I am really
            committed to helping them and we’ve had so many success stories.
          </p>
          <p>
            “Being able to share my recipes in an actual book is incredibly
            rewarding and very exciting for everyone.”
          </p>
          <p>
            “Not only have I launched a book, but I have merchandise available
            now too, I am really excited about the year ahead”
          </p>

          <div
            v-if="userAgent && !isInstagramBrowser"
            class="blog__social d-md-none"
          >
            <span class="blog__social-title">Share</span>
            <div class="d-flex">
              <div
                v-for="(link, key) in socialLinks"
                :key="key"
                class="mt-2 mr-md-0 mr-3"
                @click="handleShareClick"
              >
                <img :src="getImageItem(key)" :alt="key" />
              </div>
            </div>
          </div>

          <div v-if="tags && tags.length">
            <h2 class="mt-4">Related topics</h2>
            <div class="blog__tags">
              <Tag
                v-for="tag in tags"
                :key="tag"
                class="mr-3 my-2"
                @click="onTagClick(tag)"
              >
                {{ tag }}
              </Tag>
            </div>
          </div>

          <div class="blog__action-button mt-5">
            <Button
              class="pt-2"
              full-width
              size="sm"
              @click="handleBeFoundClick"
            >
              I’m ready to talk
            </Button>
          </div>

          <div class="blog__action-button mt-3 mb-5">
            <Button
              class="pt-2"
              full-width
              size="sm"
              variant="outline"
              @click="$router.push('/blog')"
            >
              View all blogs
            </Button>
          </div>

          <Carousel
            v-if="creatorProducts && creatorProducts.length"
            id="blog-products"
            class="my-4"
            :items="creatorProducts"
            :mode="CarouselModes.PRODUCT"
            show-default-item-actions
            @click="handleProductBundleClick"
          >
            <template #title>
              <h2>More from {{ creatorHandle }}</h2>
            </template>
          </Carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { throttle } from 'lodash';
import socialLinks from '@/misc/socialLinks';
import { CarouselModes, WebApiCancelError } from '@/misc/constants';
import Tag from '@/components/Elements/Tag.vue';
import Button from '@/components/Elements/Button.vue';
import getDefaultProductFormat from '@/misc/getDefaultProductFormat';
import formatMoney from '@/misc/formatMoney';
import getFormatPrice from '@/misc/getFormatPrice';
import { fetchProductsByCreator } from '@/services/products';
import filterProductsByRegion from '@/misc/filterProductByRegion';

export default {
  name: 'BlogItemPage',
  components: {
    Button,
    Tag,
    Carousel: () =>
      import(/* webpackPrefetch: true */ '@/components/Carousel/Index')
  },

  data() {
    return {
      creatorHandle: 'eatwellwithgeorgia',
      CarouselModes,
      socialLinks,
      creatorProducts: [],
      tags: ['Creator Stories']
    };
  },

  head: {
    title: 'Be Found | Blog'
  },

  computed: {
    ...mapState('main', ['userAgent']),
    ...mapGetters({
      isInstagramBrowser: 'main/isInstagramBrowser',
      currency: 'config/currency',
      region: 'config/region'
    })
  },

  mounted() {
    fetchProductsByCreator(this.$axios, this.creatorHandle)
      .then((response) => {
        const creatorProducts = this.$get(response, 'creatorProducts');
        this.creatorProducts = filterProductsByRegion(
          creatorProducts,
          this.region
        );
        this.contributedProducts = filterProductsByRegion(
          this.$get(response, 'contributedProducts'),
          this.region
        );
      })
      .catch((err) => {
        this.$showToastMessage(
          this.$get(err, 'response.data.message'),
          'Error',
          'danger'
        );
      });
  },

  methods: {
    getImageItem(key) {
      return require(`@/assets/icons/social/${key}.svg`);
    },

    onTagClick(tag) {
      this.$router.push('/blog?filter=' + tag);
    },

    handleBeFoundClick() {
      this.$router.push({ path: '/be-found' });
    },

    handleShareClick: throttle(function () {
      const url = window.location.href;
      if (navigator?.share) {
        navigator.share({ url }).catch((err) => {
          if (!err.message.includes(WebApiCancelError)) {
            this.$showToastMessage(err.message, 'Error', 'error');
          }
        });
      } else if (navigator?.clipboard) {
        navigator.clipboard
          .writeText(url)
          .then(() =>
            this.$showToastMessage('Link is copied', 'Success', 'success')
          )
          .catch((err) =>
            this.$showToastMessage(
              `Failed to copied link ${err.message}`,
              'Error',
              'error'
            )
          );
      } else {
        this.$showToastMessage(
          `Sharing function is not supported`,
          'Error',
          'error'
        );
      }
    }, 1500),

    getProductFormatPrice(product) {
      const defaultFormat = getDefaultProductFormat(product);
      return formatMoney(
        getFormatPrice(defaultFormat, this.region)?.amount,
        this.currency
      );
    },

    handleProductBundleClick(product) {
      this.$router.push({
        path: `/products/${product.id || product.item.id}`
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.blog {
  &__header-image {
    object-fit: cover;
    height: 480px;
    width: 100%;
  }

  &__title {
    padding-top: 40px;
    text-align: left;
    line-height: 56px;
  }

  &__landscape-image {
    object-fit: cover;
    transform: translate3d(0, 0, 1px);
    height: 550px;
    width: 100%;
    margin-bottom: 40px;
  }

  &__social {
    position: absolute;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    text-align: center;

    &-title {
      font-size: 12px;
    }
  }

  &__double-image {
    display: flex;
    justify-content: space-around;

    img {
      object-fit: cover;
      height: 700px;
      &:first-child {
        margin-right: 20px;
      }
    }
  }

  &__quote {
    font-family: 'Poppins-SemiBold', sans-serif;
    font-size: 24px;
    border-left: 8px solid $primary-color;
    padding-left: 35px;
  }

  &__action-button {
    margin: 0 auto;
    max-width: 240px;
  }

  @media (max-width: $screen-width-md) {
    &__header-image {
      object-fit: contain;
      height: 242px;
    }

    &__landscape-image {
      height: 328px;
    }

    &__double-image {
      flex-wrap: wrap;

      img {
        margin-bottom: 25px;
        object-fit: cover;
        height: 420px;
        &:first-child {
          margin-right: 0;
        }
      }
    }

    &__social {
      position: initial;
      flex-direction: column;
      text-align: left;
    }
  }
}
</style>
